import * as React from "react";
import { SVGProps } from "react";
const SvgRadioCheckboxRing03 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#radio-checkbox-ring-03_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0Zm0 21a4.969 4.969 0 0 1-5-5c0-2.786 2.214-5 5-5s5 2.214 5 5-2.214 5-5 5Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="radio-checkbox-ring-03_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRadioCheckboxRing03;
